import React from 'react';
import { Sparkles, BrainCircuit, CloudLightning, Apple, ShieldAlert, X } from 'lucide-react';

const WhatsNewAiModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleClose = () => {
    localStorage.setItem('hasSeenAiElite', 'true');
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(5, 8, 16, 0.95)', animation: 'fadeIn 0.3s ease'
    }}>
      <div className="glass-panel slide-up" style={{
        maxWidth: '500px', width: '90%', padding: '2rem', display: 'flex', flexDirection: 'column',
        position: 'relative', maxHeight: '90vh', overflowY: 'auto'
      }}>
        <button onClick={handleClose} style={{
          position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none',
          color: 'var(--text-secondary)', cursor: 'pointer'
        }}>
          <X size={24} />
        </button>

        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ background: 'var(--soma-accent-glow)', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem' }}>
            <Sparkles size={32} color="var(--soma-accent)" />
          </div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 800, color: 'var(--text-primary)', marginBottom: '0.5rem' }}>
            Entrenador IA Élite (v2.0)
          </h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
            Hemos potenciado nuestro motor de Inteligencia Artificial para que actúe como un verdadero fisiólogo deportivo. Descubre las 4 nuevas funciones:
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
          
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
            <div style={{ padding: '0.5rem', background: 'rgba(239, 68, 68, 0.1)', borderRadius: '8px' }}>
              <ShieldAlert size={24} color="#ef4444" />
            </div>
            <div>
              <strong style={{ display: 'block', color: 'white', marginBottom: '0.2rem' }}>Alertas Predictivas de Lesión</strong>
              <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Si detectamos una caída brusca en tu VFC (HRV) combinada con mucha fatiga (TSB), la IA te advertirá proactivamente de que debes parar para evitar lesiones o enfermedades.</span>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
            <div style={{ padding: '0.5rem', background: 'rgba(16, 185, 129, 0.1)', borderRadius: '8px' }}>
              <Apple size={24} color="#10b981" />
            </div>
            <div>
              <strong style={{ display: 'block', color: 'white', marginBottom: '0.2rem' }}>Nutrición Matemática</strong>
              <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Al analizar una actividad, ya no te damos consejos vagos. Calculamos los gramos exactos de carbohidratos y proteínas que necesitas ingerir para recuperar las calorías quemadas.</span>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
            <div style={{ padding: '0.5rem', background: 'rgba(0, 229, 255, 0.1)', borderRadius: '8px' }}>
              <CloudLightning size={24} color="#00e5ff" />
            </div>
            <div>
              <strong style={{ display: 'block', color: 'white', marginBottom: '0.2rem' }}>Contexto Meteorológico</strong>
              <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Nuestro sistema ahora detecta automáticamente a qué temperatura entrenaste conectándose a satélites históricos, para que la IA entienda si sufriste por calor extremo.</span>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
            <div style={{ padding: '0.5rem', background: 'rgba(168, 85, 247, 0.1)', borderRadius: '8px' }}>
              <BrainCircuit size={24} color="#a855f7" />
            </div>
            <div>
              <strong style={{ display: 'block', color: 'white', marginBottom: '0.2rem' }}>Briefing Matutino</strong>
              <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Cada mañana, revisa la Pestaña "Salud" (Predisposición Diaria). Tu entrenador te dejará un consejo de 1 frase basado en tu sueño de anoche y fatiga actual.</span>
            </div>
          </div>

        </div>

        <button 
          onClick={handleClose}
          style={{
            marginTop: '2rem', width: '100%', padding: '0.875rem', background: 'var(--soma-accent)', 
            color: 'white', border: 'none', borderRadius: '8px', fontWeight: 600, fontSize: '1rem', cursor: 'pointer'
          }}
          className="pulse-glow"
        >
          ¡Entendido, a exprimirlo!
        </button>

      </div>
    </div>
  );
};

export default WhatsNewAiModal;
